/* eslint-disable import/no-extraneous-dependencies */
// polyfills for IE
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'fast-text-encoding';

import React from 'react';
import ReactDOM from 'react-dom';

import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import App from './App';
import { getPluginId } from './helpers';

Bugsnag.start({
  apiKey: 'f82c255da2c5f11f36eff96871c639ea',
  plugins: [new BugsnagPluginReact()]
});

const ErrorBoundary = Bugsnag.getPlugin('react')
  .createErrorBoundary(React);
ReactDOM.render(
  <ErrorBoundary>
    <App pluginId={getPluginId()} class="app" />
  </ErrorBoundary>,
  document.getElementById(process.env.REACT_APP_ROOT_ID)
);
